import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";


const ProjectProfitWidgets = ({ plan, total_profit, percent }) => {
  return (
    <ProfitWidgetsStyled>
      <div className="row">
        <div className="col-md-4">
          <div className="mini-stats-wid card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1"><p className="text-muted fw-medium">Plan</p><h4
                  className="mb-0">{plan}</h4></div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <i className="bx bx-copy-alt font-size-24" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="mini-stats-wid card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1"><p className="text-muted fw-medium">Total profit</p><h4
                  className="mb-0">{total_profit}</h4></div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <i className="mdi mdi-finance font-size-24" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="mini-stats-wid card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1"><p className="text-muted fw-medium">Percent</p><h4
                  className="mb-0">{percent.toFixed(2)}%</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <i className="mdi mdi-percent-outline font-size-24" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProfitWidgetsStyled>
  );
};

ProjectProfitWidgets.propTypes = {
  plan: PropTypes.number,
  total_profit: PropTypes.number,
  percent: PropTypes.string
};

const ProfitWidgetsStyled = styled.div`
`;

export default ProjectProfitWidgets;
